module.exports = __webpack_public_path__ + "static/media/flask_logo.2fa425be.png";